export default function getSvgBorderLineMap({

  borderThickness, 

  width,
  height,


  borderTopX1,
  borderTopX2,
  
  borderBottomX1,
  borderBottomX2,

  topBracketHeight,
  bottomBracketHeight,

  relX,
  rectRelY,

  borderLeftYOffset,
  borderRightYOffset,

  leftBracketWidth,
  rightBracketWidth,

  missingBorder,


}){

  let thicknessShift = borderThickness / 2;

  let borderLineMap = {
      borderTop:{
        x1:borderTopX1 + thicknessShift,
        y1:(rectRelY) + thicknessShift,
        x2:borderTopX2 - thicknessShift,
        y2:(rectRelY) + thicknessShift,

        shapeRendering:"crispEdges",

      },
      borderTopLeftBracket:{
        x1:borderTopX1 + 0.5 + thicknessShift,
        y1:rectRelY,
        x2:borderTopX1 + 0.5 + thicknessShift,
        y2:rectRelY + topBracketHeight,

      },

      borderTopRightBracket:{
        x1:borderTopX2 - 0.5 - thicknessShift,
        y1:rectRelY,
        x2:borderTopX2 - 0.5 - thicknessShift,
        y2:rectRelY + topBracketHeight
      },


      borderBottom:{
        x1:borderBottomX1 + thicknessShift,
        y1:rectRelY + height - thicknessShift,
        x2:borderBottomX2 - thicknessShift,
        y2:rectRelY + height - thicknessShift,

        shapeRendering:"crispEdges",

        //stroke:'magenta',
      },
      borderBottomLeftBracket:{
        x1:borderBottomX1 + 0.5 + thicknessShift,
        y1:rectRelY + height,
        x2:borderBottomX1 + 0.5 + thicknessShift,
        y2:rectRelY + height - bottomBracketHeight,
      },

      borderBottomRightBracket:{
        x1:borderBottomX2 - 0.5 - thicknessShift,
        y1:rectRelY + height,
        x2:borderBottomX2 - 0.5 - thicknessShift,
        y2:rectRelY + height - bottomBracketHeight,
        //stroke:'magenta',
      },


      borderLeft:{
        x1:relX + thicknessShift,
        y1:( rectRelY + borderLeftYOffset - missingBorder + thicknessShift ),
        x2:relX + thicknessShift,
        y2:rectRelY+ height - borderLeftYOffset + missingBorder - thicknessShift,
        shapeRendering:"crispEdges",
      },
      borderRight:{
        x1:relX+width + 0.5 - thicknessShift,
        y1:rectRelY + borderRightYOffset - missingBorder + thicknessShift,
        x2:relX+width + 0.5 - thicknessShift,
        y2:rectRelY+height - borderRightYOffset + missingBorder - thicknessShift,
        shapeRendering:"crispEdges",
      },

      borderRightTopBracket:{
        x1:relX+width,
        y1:rectRelY + borderRightYOffset,
        x2:relX+width - rightBracketWidth,
        y2: rectRelY + borderRightYOffset
      },

      borderRightBottomBracket:{

        x1:relX+width,
        y1:rectRelY  + height - borderRightYOffset,
        x2:relX+width - rightBracketWidth,
        y2: rectRelY + height - borderRightYOffset,
      },

      borderLeftTopBracket:{
        x1:relX,
        y1:rectRelY + borderLeftYOffset,
        x2:relX + leftBracketWidth,
        y2: rectRelY + borderLeftYOffset
      },

      borderLeftBottomBracket:{
        x1:relX,
        y1:rectRelY + height - borderLeftYOffset,
        x2:relX + leftBracketWidth,
        y2: rectRelY + height - borderLeftYOffset

      }
    }

  return borderLineMap;

}
